export default "__VITE_ASSET__UnlH_GAc__"